import { base64Image } from "./icon";
const walletInfo = {
    name: "Vultisig",
    icon: base64Image,
    install: {
        chrome: "https://chromewebstore.google.com/detail/vulticonnect/ggafhcdaplkhmmnlbfjpnnkepdfjaelb",
        ios: "https://apps.apple.com/app/vultisig/id6503023896",
        android: "https://play.google.com/store/apps/details?id=com.vultisig.wallet",
    },
    isChainSupported: () => {
        return true;
    },
    errors: {
        generic: [],
    },
};
export const vultisigWallet = {
    provider: () => {
        const vultisig = window.vultisig;
        if (!vultisig) {
            return { installed: false };
        }
        return Object.assign(vultisig, {
            installed: true,
        });
    },
    info: walletInfo,
};
//# sourceMappingURL=index.js.map